import { SectionHeader } from "@/components/ui/SectionHeader";
import { Phone, ClipboardCheck, FolderOpen, Calendar } from "lucide-react";

const steps = [
  {
    number: "1",
    icon: Phone,
    title: "Book a Call",
    description: "Schedule a free consultation to discuss your business needs and current bookkeeping situation.",
  },
  {
    number: "2",
    icon: ClipboardCheck,
    title: "We Assess Your Business",
    description: "We review your systems, understand your requirements, and recommend the right package for you.",
  },
  {
    number: "3",
    icon: FolderOpen,
    title: "Onboarding & Documents",
    description: "We guide you through onboarding, request necessary documents, and set up your accounts.",
  },
  {
    number: "4",
    icon: Calendar,
    title: "Monthly Delivery",
    description: "Sit back while we handle your books, compliance deadlines, and keep you SARS-ready.",
  },
];

export function HowItWorks() {
  return (
    <section className="py-20 lg:py-28 section-light">
      <div className="container mx-auto px-4">
        <SectionHeader
          label="Process"
          title="How It Works"
          description="Getting started is simple. We handle the complexity so you don't have to."
        />

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              {/* Connector line (desktop) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[calc(50%+2rem)] w-[calc(100%-4rem)] h-0.5 bg-border" />
              )}
              
              <div className="text-center">
                <div className="step-number mx-auto mb-6 relative z-10">
                  {step.number}
                </div>
                <div className="icon-container mx-auto mb-4">
                  <step.icon className="w-6 h-6" />
                </div>
                <h3 className="font-heading text-xl font-semibold text-foreground mb-3">
                  {step.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
